import { useLayoutEffect, type RefObject } from 'react'

/**
 * Keeps a scroll container pinned to its last message.
 *
 * Two things move the floor out from under a plain scrollIntoView: the dock
 * changes height between onboarding steps (different chip counts), and the
 * composer grows as you type. So the dock is observed too, not just the deps.
 */
export function useStickToBottom(
  scroller: RefObject<HTMLElement | null>,
  dock: RefObject<HTMLElement | null>,
  deps: unknown[],
) {
  useLayoutEffect(() => {
    const el = scroller.current
    if (!el) return

    const toBottom = () => { el.scrollTop = el.scrollHeight }
    toBottom()
    const raf = requestAnimationFrame(toBottom)
    const timer = setTimeout(toBottom, 150)

    const observer = dock.current ? new ResizeObserver(toBottom) : null
    if (observer && dock.current) observer.observe(dock.current)

    return () => {
      cancelAnimationFrame(raf)
      clearTimeout(timer)
      observer?.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
